import React from "react";
import Modal from "src/components/modal/modal";
import { useDeletePostByIdMutation } from "src/features/feed/post.service";
import { useAppDispatch } from "src/store";
import { showToast } from "src/store/toast.store";

type DeletePostProps = {
  id: string;
  handleClose: () => void;
};

export const DeletePostModel = ({ id, handleClose }: DeletePostProps) => {
  const dispatch = useAppDispatch();
  const [deletePost] = useDeletePostByIdMutation();

  const handleDelete = async () => {
    try {
      await deletePost(id);
      dispatch(
        showToast({
          type: "success",
          message: "Post deleted successfully",
        })
      );
    } catch (error) {
      dispatch(
        showToast({
          type: "error",
          message: "Failed to delete the post",
        })
      );
    }
  };
  return (
    <Modal onClose={handleClose} isOpen={true} hideFooter={true}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Are you sure you want to delete this post?</h3>
      <p className="text-sm text-gray-600">This action cannot be undone. The post will be permanently removed.</p>

      <div className="flex justify-end mt-6 border-t pt-4 border-gray-200 gap-3">
        <button
          onClick={handleClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md cursor-pointer transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleDelete}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md cursor-pointer shadow-sm transition-colors"
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};
